"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const { withFlags, withFlagProvider } = require("ld-react");
const { Provider, Consumer } = require("ld-react/lib/context");
exports.withFeatureFlagsProvider = withFlagProvider;
exports.withFeatureFlags = withFlags;
exports.withFeatureFlag = (flagName) => Component => props => (React.createElement(Consumer, null, (flags) => {
    if (!flags[flagName]) {
        return null;
    }
    return React.createElement(Component, Object.assign({}, props));
}));
class MockFeatureFlagProvider extends React.Component {
    render() {
        return React.createElement(Provider, { value: this.props.flags }, this.props.children);
    }
}
exports.MockFeatureFlagProvider = MockFeatureFlagProvider;
